export const sponsors = {
  platinum: [
    { name: "iCatCare", logo: require("../../assets/sponsored_content/logos/iCatCare.jpg"), link: "https://icatcare.org", },
  ],
  gold: [
    {
      name: "Dimedium", logo: require("../../assets/sponsored_content/logos/Dimedium.png"), link: "https://www.dimedium.lv",
      description: `Dimedium Latvija ir viens no vadošajiem veterināro medikamentu, specializētās barības un aprūpes produktu izplatītājiem Latvijā. Sadarbojoties ar veterinārārstiem un klīnikām, piedāvājam zinātnē balstītus un kvalitatīvus risinājumus kaķu veselības atbalstam.
      
      SPECIFIC - gremošanas sistēmas atbalstam kaķiem

Dimedium Latvija ir oficiālais SPECIFIC® veterināro diētu izplatītājs Baltijā. SPECIFIC® piedāvā zinātniski izstrādātas formulas, kas palīdz stabilizēt gremošanas traktu, uzlabot barības vielu uzsūkšanos un atjaunot zarnu mikrobiota līdzsvaru:

FID & FIW - viegli sagremojamas barības ar postbiotikām un AuraGuard zarnu barjeras stiprināšanai.
FØD-HY & FØW-HY - hidrolizētu proteīnu formulas gremošanas traucējumiem ar iespējamu alerģisku komponenti.
FDD-HY & FDW - ierobežotu sastāvdaļu diētas vemšanas un caurejas gadījumos.
FRD & FRW - zema tauku satura barība gremošanas atbalstam un svara kontrolei.

Vebiot - ikdienas veselības atbalsts
Dimedium Latvija piedāvā arī Vebiot papildbarības, kas palīdz uzturēt veselīgu mikrobiomu, gremošanas funkciju un imunitāti, nodrošinot efektīvu atbalstu dažādām klīniskajām situācijām. 

PlaqueOff - dabisks risinājums mutes higiēnai
PlaqueOff® pulveris un našķi ir starptautiski atzīts līdzeklis zobu veselības uzlabošanai, kas palīdz samazināt aplikumu, zobakmeni un nodrošināt svaigu elpu ikdienā.

Mirataz - atbalsts apetītes trūkuma gadījumā
Mirataz ir efektīvs preparāts kaķiem ar apetītes zudumu vai hronisku svara samazināšanos, palīdzot stabilizēt ķermeņa masu un uzlabot dzīvnieka pašsajūtu atveseļošanās laikā.`,
      files: [{ name: "SPECIFIC - gremošanas sistēmas atbalstam kaķiem", file: require("../../assets/sponsored_content/dimedium/Specific Post-biotics.png") }, { name: "Vebiot - ikdienas veselības atbalsts", file: require("../../assets/sponsored_content/dimedium/Vebiot30.pdf") }],
      videoURL: "https://www.youtube.com/embed/oD9-1QsdPik?si=ZHCsAHTfpYQpS7eA"

    },
  ],
  silver: [
    { name: "Novus Vet", logo: require("../../assets/sponsored_content/logos/NovusVet.png"), link: "https://www.novusvet.lv/", },
    { name: "Feliway", logo: require("../../assets/sponsored_content/logos/Feliway.jpg"), link: "", },
  ],
  bronze: [
    { name: "DR.VET", logo: require("../../assets/sponsored_content/logos/DrVet.png"), link: "https://drvet.lv/", },
    // { name: "KRKA", logo: require("../../assets/sponsored_content/logos/KRKA.png"), link: "https://www.krka.lv/", },
  ],
  promo: [
    
    { name: "Hill's", logo: require("../../assets/sponsored_content/logos/Hills.jpeg"), link: "https://www.hillspet.lv/", },
  ],
};